export enum ScheduleType {
    none = 0,
    exterior = 6,
    interior = 7
}
